import { useMemo } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'

import { useGetStaffsByEstablishmentQuery } from '@/core/services/staff'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import AgendaDrawer, { AgendaDrawerProps } from '../components/AgendaDrawer'

export default function AgendaDrawerContainer(props: Omit<AgendaDrawerProps, 'staffOptions'>) {
  // orderStatusFilter and onOrderStatusFilterChange are passed through via ...props
  const authUser = useAppSelector(selectAuthUser)

  const { data: staffs } = useGetStaffsByEstablishmentQuery(authUser?.establishment?._id ?? skipToken)

  const staffOptions = useMemo(
    () =>
      staffs?.map((staff) => ({
        label: `${staff.userInfo.name} ${staff.userInfo.surname}`,
        value: staff._id,
      })) ?? [],
    [staffs]
  )

  return <AgendaDrawer {...props} staffOptions={staffOptions} />
}
